import * as amplitude from '@amplitude/analytics-browser';

if (process.env.REACT_APP_AMPLITUDE_API_KEY) {
  amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY, {
    defaultTracking: true,
    autocapture: {
      elementInteractions: true,
      fileDownloads: true,
      formInteractions: true,
      pageViews: true,
      sessions: true,
    },
  });
}
